export const JIRA_EDITION_AWARENESS_FOR_STANDARD_TO_PREMIUM_PACKAGE_NAME =
	'jiraEditionAwarenessForStandardToPremium' as const;

export const JIRA_EDITION_AWARENESS_FOR_STANDARD_TO_PREMIUM_PILL_DISMISSED =
	'jira.user.theme.standard-to-premium-ea-pill.dismissed' as const;
